module.exports = __webpack_public_path__ + "static/media/04_profile_picture.b0e8a9d8.png";